export default __webpack_public_path__ + "8b81cc823c3a6ea821e72928b8a833f5.png";